











import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

import {VSelect} from 'vuetify/lib'
import {ValidationProvider} from 'vee-validate'
import ColorCard from '@/components/ColorCard.vue'

@Component({
  components: {ColorCard, VSelect, ValidationProvider},
  name: 'SelectFieldWithValidation',
})
export default class SelectFieldWithValidation extends Vue {
  @Prop({
    type: [String, Object],
    default: '',
  }) public readonly rules: any

  @Prop({
    type: String,
    default: null,
  }) public readonly value!: string | boolean | null

  public innerValue: string | boolean | null = null

  @Watch('innerValue')
  public onInnerValueChange(newVal: any) {
    this.$emit('input', newVal)
  }

  @Watch('value')
  public onValueChange(newVal: any) {
    this.innerValue = newVal
  }

  public created() {
    if (this.value !== null) {
      this.innerValue = this.value
    }
  }
}
